import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue
} from '@/components/shadcn/Select';

type Year = {
  date: '年';
  placeholder: '入社年' | '退社年';
};

type Month = {
  date: '月';
  placeholder: '入社月' | '退社月';
};

type Props = {
  value: string;
  onChange: (arg: string) => void;
  optionElements: JSX.Element[];
  className: string;
  disabled?: boolean;
} & (Year | Month);

export default function WorkplaceDate({
  value,
  onChange,
  optionElements,
  className,
  date,
  placeholder,
  disabled = false
}: Props) {
  return (
    <Select
      value={value}
      onValueChange={onChange}
      className="w-[calc(50%-10px)]"
      disabled={disabled}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder}>
          {value ? value + date : ''}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>{optionElements}</SelectContent>
    </Select>
  );
}
